import { LocalizedData, LocalizedString } from '../../common';

const recommendationTitleRegex = /\{.*?\}/g;

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function formatRecommendationLocalizedTitle(
  localizedTitle: LocalizedData<string>,
  baseLocalizedTitle: LocalizedString
): LocalizedString {
  if (!localizedTitle) {
    return baseLocalizedTitle;
  }
  return {
    en: baseLocalizedTitle.en?.replace(recommendationTitleRegex, localizedTitle.en),
    ar: baseLocalizedTitle.ar?.replace(recommendationTitleRegex, localizedTitle.ar),
  };
}
